import { FieldArray, Form, Formik } from "formik";
import FormInputText from "../../../components/Forms/FormInputText";
import FormSelectBox from "../../../components/Forms/FormSelectBox";
import FormCheckbox from "../../../components/Forms/FormCheckbox";
import { Button, Form as BTForm } from "react-bootstrap";
import { euroFormatter } from "../../../global";
import React, { useEffect, useRef, useState } from "react";
import axios from "../../../config/axios";
import { useTranslation } from "react-i18next";
import moment from "moment";

const EditInvoiceForm = ({ invoice, handleSubmit, formRef }) => {
  function validate(values) {
    const errors = {};
    return errors;
  }

  function submit(data, { setSubmitting }) {
    setSubmitting(true);
    handleSubmit(data);
  }

  const [template, setTemplate] = useState();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    axios.get(`/api/v1/invoices/settings.json`).then(function ({ data }) {
      setTemplate(data);
    });
  }, []);

  if (!invoice || !template) {
    return <></>;
  }

  return (
    <Formik
      initialValues={{
        ...invoice,
        fiscal_receipt_time: invoice.fiscal_receipt_time
          ? moment(invoice.fiscal_receipt_time).format(moment.HTML5_FMT.TIME)
          : "",
        items_attributes:
          invoice.items?.length > 0
            ? invoice.items
            : [
                {
                  description: "",
                  quantity: 1,
                  unit_price: 0,
                  fiscal_department_mapping_id:
                    template.settings.default_fiscal_department_mapping.id,
                },
              ],
      }}
      enableReinitialize={true}
      innerRef={formRef}
      validate={validate}
      onSubmit={submit}
    >
      {({ values, setFieldValue }) => (
        <Form autoComplete="false">
          <FieldArray name="items_attributes">
            {({ insert, replace, push }) => (
              <div>
                {values.items_attributes.map((item, index) => {
                  const total_price = item.unit_price * item.quantity;

                  if (!item._destroy) {
                    return (
                      <div className={"d-flex align-items-end"} key={index}>
                        <div className={"mr-1"} style={{ width: "500px" }}>
                          <FormInputText
                            label="Beschreibung"
                            name={`items_attributes.${index}.description`}
                            required
                            placeholder={"Beschreibung"}
                            disabled={values.fiscal_printed_at}
                          />
                        </div>
                        <div className={"w-80px mr-1"}>
                          <FormInputText
                            label="Anzahl"
                            name={`items_attributes.${index}.quantity`}
                            required
                            disabled={values.fiscal_printed_at}
                          />
                        </div>
                        <div className={"mr-1"} style={{ width: "120px" }}>
                          <FormInputText
                            label="Einzelpreis (Brutto)"
                            name={`items_attributes.${index}.unit_price`}
                            required
                            disabled={values.fiscal_printed_at}
                          />
                        </div>
                        <div className={"mr-1"} style={{ width: "120px" }}>
                          <FormSelectBox
                            label="Steuersatz"
                            name={`items_attributes.${index}.fiscal_department_mapping_id`}
                            options={
                              template.settings.fiscal_department_mappings
                            }
                            required
                            option_value={"id"}
                            disabled={values.fiscal_printed_at}
                          />
                        </div>
                        <div className={"mr-1"} style={{ width: "120px" }}>
                          <BTForm.Group className="mb-3">
                            <BTForm.Label>Gesamtpreis</BTForm.Label>
                            <BTForm.Control
                              value={total_price}
                              readOnly={true}
                            />
                          </BTForm.Group>
                        </div>
                        <Button
                          variant={"danger"}
                          className={"mr-1 mb-3 h-50"}
                          onClick={() => {
                            replace(index, { ...item, _destroy: true });
                          }}
                          disabled={invoice.status === "paid"}
                        >
                          Löschen
                        </Button>
                      </div>
                    );
                  }
                })}

                <div className={"d-flex mb-3"}>
                  <strong>{t("editBookingInvoice.total_value")}:</strong>&nbsp;
                  <span>
                    {euroFormatter(
                      values.items_attributes
                        .filter((item) => !item._destroy)
                        .reduce((current, accumulator) => {
                          const total_price =
                            accumulator.unit_price * accumulator.quantity;
                          return current + total_price;
                        }, 0)
                    )}
                  </span>
                </div>

                <Button
                  variant={"secondary"}
                  className={"mr-1 mb-3 h-50"}
                  onClick={() => {
                    insert(values.items_attributes.length, {
                      quantity: 1,
                      unit_price: 0,
                      description: "",
                      fiscal_department_mapping_id:
                        template.settings.default_fiscal_department_mapping.id,
                    });
                  }}
                  disabled={invoice.status === "paid"}
                >
                  Artikel hinzufügen
                </Button>
              </div>
            )}
          </FieldArray>

          <FormCheckbox
            name="fiscal_printed_at"
            label="Quittung erstellt"
            className="mb-2"
            onChange={(e) => {
              setFieldValue(
                "fiscal_printed_at",
                e.target.checked ? new Date() : ""
              );
            }}
          />

          {values.fiscal_printed_at && (
            <>
              <FormInputText
                label={t("editBookingInvoice.fiscal_receipt_number.label")}
                hint={t("editBookingInvoice.fiscal_receipt_number.hint")}
                name="fiscal_receipt_number"
              />
              <FormInputText
                label={t("editBookingInvoice.fiscal_receipt_amount.label")}
                name="fiscal_receipt_amount"
                type={"number"}
              />
              <FormInputText
                label={t("editBookingInvoice.fiscal_receipt_date.label")}
                name="fiscal_receipt_date"
                type={"date"}
              />
              <FormInputText
                label={t("editBookingInvoice.fiscal_receipt_time.label")}
                name="fiscal_receipt_time"
                type={"time"}
              />
              <FormInputText
                label={t("editBookingInvoice.fiscal_receipt_rep_number.label")}
                hint={t("editBookingInvoice.fiscal_receipt_rep_number.hint")}
                name="fiscal_receipt_rep_number"
              />
            </>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default EditInvoiceForm;
